<div (click)="openInfoDialog($event)" [class]="buttonClass"></div>
